// extracted by mini-css-extract-plugin
module.exports = {"live-list":"style_live-list__YCAXI"};